<template>
  <div class="col-12">
    <Dialog header="Update Assessment Date" v-model:visible="modal">
      <Calendar v-model="date" :inline="true"/>
      <template #footer>
        <Button label="Close" icon="pi pi-times" class="p-button-text" @click="Cancel"/>
        <Button label="Ok" icon="pi pi-check" autofocus  @click="SaveDates()"/>
      </template>
    </Dialog>
  </div>
  
            <!--<v-dialog ref="dialog"
                      v-model="modal"
                      :return-value.sync="date"
                      persistent
                      width="290px">-->
                <!--<template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date"
                                  label="Picker in dialog"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"></v-text-field>
                </template>-->
                <!--<v-date-picker v-model="date"
                               elevation="15"
                               scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text
                           color="primary"
                           @click="Cancel">
                        Cancel
                    </v-btn>
                    <v-btn text
                           color="primary"
                           @click="SaveDates()">
                        OK
                    </v-btn>
                </v-date-picker>-->
            <!--</v-dialog>-->
    

</template>


<script>
  import Calendar from 'primevue/calendar';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';

    export default  {
    name: 'EditDate',
    components: {
      Calendar,
      Dialog,
      Button
    },
    data: () => ({
            Content: '',
            date: '',
            modal:true,
            SuccessUpload: false,
            SuccessUploadMessage: '',
            SuccessUploadSnack:false,
            ErrorUploadMessage: '',
            ErrorUploadSnack: false,
        }),
        beforeMounted() {
            console.log(this.params.date())
            this.date = this.params.date()
        },
        methods: {
            getValue() {
                return this.date;
            },

            isPopup() {
                return true;
            },
            onClick() {
                this.params.api.stopEditing(true);
            },
            onKeyDown(event) {
                let key = event.which || event.keyCode;
                if (
                    key == 37 || // left
                    key == 39
                ) {
                    // right
                    event.stopPropagation();
                }
            },
            Cancel() {
                this.params.api.stopEditing(true);
            },
            SaveDates() {
                this.params.api.stopEditing(false);
            }
        },

    };

</script>